import { render } from "./CalendarDay.vue?vue&type=template&id=023d1ade&scoped=true"
import script from "./CalendarDay.vue?vue&type=script&lang=js"
export * from "./CalendarDay.vue?vue&type=script&lang=js"

import "./CalendarDay.vue?vue&type=style&index=0&id=023d1ade&scoped=true&lang=css"
import "./CalendarDay.vue?vue&type=style&index=1&id=023d1ade&scoped=true&lang=css"
import "./CalendarDay.vue?vue&type=style&index=2&id=023d1ade&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-023d1ade"]])

export default __exports__